<ng-template #customerView>
  <div class="container-fluid-0px">
    <div class="row mb-3">
      <div class="col-12" [ngClass]="ownerUserId?'col-lg-6 col-xl-7 col-xxl-8 order-1 order-lg-0':''">
        <app-open-invoices-table></app-open-invoices-table>
      </div>
      <div class="col-12 col-lg-6 col-xl-5 col-xxl-4 order-0 order-lg-1" *ngIf="ownerUserId">
        <payout-preview  [amountDue]="payoutAmountDue" [customerUserId]="ownerUserId"></payout-preview>
      </div>
    </div>
    <div class="row">
      <app-invoices-table></app-invoices-table>
    </div>
  </div>
   
</ng-template>

<ng-template #userView>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <app-invoices-table></app-invoices-table>
      </div>
    </div>
  </div>
</ng-template>

<main id="invoices" *ngIf="isOperator">
  <ng-container *ngTemplateOutlet="customerView"></ng-container>
</main>

<main id="invoices" *ngIf="isCustomer">
  <ng-container *ngTemplateOutlet="customerView"></ng-container>
</main>

<main id="invoices" *ngIf="isUser">
  <ng-container *ngTemplateOutlet="userView"></ng-container>
</main>

<router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
